jQuery(document).ready(function($) {

    if (! Foundation.MediaQuery.atLeast('large')) {
        $('ul.accordion').foundation('toggle', $('.accordion-content'));
    }

    function getMaterialesArgs() {
        var ms = $("#ms").val();
        var mter = $('input[type=checkbox]:checked').attr('id');
        mter = mter == undefined ? "" : mter;
        var mtags = $('select[name=mtags]').val();
        mtags = mtags == null ? [] : mtags;
        return {
            'ms': ms,
            'mter': mter,
            'mtag': mtags.join(','),
        };
    }

    function searchMateriales(page) {
        page = page || 1;
    	var ajax_data = getMaterialesArgs();
        ajax_data['action'] = 'get_materiales';
        ajax_data['page'] = page;

        var accordion = $('.accordion-title');
        if (accordion.css('display') !== 'none' && $('.accordion-item').hasClass('is-active')) {
            accordion.click();
        }

        $.ajax({
            url: Ajax.url,
            type: 'GET',
            data: ajax_data,
            success: function(data) {
                var j_data = JSON.parse(data);
                $('.spinner').hide();
                $('.row.entries').html(j_data.content);
                $('.pagination-nav').html(j_data.pagination);
                var count = j_data.found_posts;
                var msg = count == 1 ? 'material disponible' : 'materiales disponibles';
                $('.count').html(count + ' ' + msg);
                if (count == 0) {
                    $('#count').addClass('hide');
                    $('#404').removeClass('hide');
                } else {
                    $('#404').addClass('hide');
                    $('#count').removeClass('hide');
                }
            },
            beforeSend: function() {
                $('.row.entries').html();
                $('.spinner').show();
            }
        });
    }

    $('.button.mter').on('click', function(ev) {
        ev.preventDefault();
        var obj = $(this);
        var checkbox_id = obj.attr('for');
        if ($('#' + checkbox_id).is(':checked')) {
            $('#' + checkbox_id).attr('checked', false);
        } else {
            $('input[type=checkbox]:checked').attr('checked', false);
            $('#' + checkbox_id).attr('checked', true);
        }
        searchMateriales();
    });

    $('.multitag-completion').on('change', function(ev) {
    	ev.preventDefault();
    	searchMateriales();
    });

   	$('#ms').on('keypress', function(ev) {
   		if (ev.keyCode == 13) {
   			ev.preventDefault();
   			searchMateriales();
   		}
   	});

    $('#msearchsubmit').on('click', function(ev) {
    	ev.preventDefault();
    	searchMateriales();
    });

    $(document).on('click', '.pagination-nav a' , function(ev) {
        var obj = $(this);
        ev.preventDefault();
        searchMateriales(obj.data('page'));
    });
});